import type { Container } from 'pixi.js';

export function registerResizableObject(
  object: Container & { resize: (width: number, height: number) => unknown },
): void {
  registerResizableObjectWithCallback(object, (w, h) => object.resize(w, h));
}

export function registerResizableObjectWithCallback(
  object: Container,
  callback: (width: number, height: number) => void,
): void {
  const callBackWrapper = async (): Promise<void> => {
    // TODO get rid of horizontal layout state from app state data
    await object.wait(1);
    const { width, height } = object.pixi.renderer;
    callback(width, height);
  };

  object.pixi.renderer.on('resize', callBackWrapper);
  object.once('destroyed', () => {
    object.pixi.renderer.off('resize', callBackWrapper);
  });

  callback(object.pixi.renderer.width, object.pixi.renderer.height);
}
